import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

export const DOC = gql`
  mutation AddClusterResponsiblePersons(
    $tenantId: ID!
    $zoneId: ID!
    $appId: ID!
    $scenarioId: ID!
    $clusterId: ID!
    $employeeIds: [ID!]!
    $primaryResponsiblePersonId: ID
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          scenario(id: $scenarioId) {
            extra {
              space {
                addClusterResponsiblePersons(
                  clusterId: $clusterId
                  employeeIds: $employeeIds
                  primaryResponsiblePersonId: $primaryResponsiblePersonId
                )
              }
            }
          }
        }
      }
    }
  }
`

export const executor = graphql.createExecutor<
  graphql.schema.AddClusterResponsiblePersonsMutation,
  undefined,
  graphql.schema.AddClusterResponsiblePersonsMutationVariables
>({
  query: DOC,
  transformer: graphql.transformers.OUT.always(undefined),
})
